import { actions } from '../actions';
import { initialState } from '../constants/initialState';
import { arrayInsertRemove } from '../utils/utils';

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.activeChat:
      return {
        ...state,
        activeChat: action.id,
      };
    case actions.activeChatShowChatsNoEnded:
      return {
        ...state,
        activeChatShowChatsNoEnded: action.show,
      };
    case actions.countChats:
      return {
        ...state,
        countChats: action.countChats,
      };
    case actions.ordered:
      return {
        ...state,
        ordered: { ...state.ordered, ...action.ordered },
      };
    case actions.chatsCount:
      return {
        ...state,
        ordered: {
          ...state.ordered,
          chatsCount: action.chatsCount,
        },
      };
    case actions.filterStatus:
      return {
        ...state,
        filter: {
          ...state.filter,
          local: {
            ...state.filter.local,
            status: arrayInsertRemove(state.filter.local.status, action.status),
          },
        },
      };
    case actions.filterType:
      return {
        ...state,
        filter: {
          ...state.filter,
          local: {
            ...state.filter.local,
            type: action.typeValue,
          },
        },
      };
    case actions.filterKeyword:
      return {
        ...state,
        filter: {
          ...state.filter,
          query: {
            ...state.filter.query,
            keyword: action.keyword,
          },
        },
      };
    case actions.filterDate:
      return {
        ...state,
        filter: {
          ...state.filter,
          query: {
            ...state.filter.query,
            date: action.date,
          },
        },
      };
    case actions.filterBotStopped:
      return {
        ...state,
        filter: {
          ...state.filter,
          local: {
            ...state.filter.local,
            botStopped: action.botStopped,
          },
        },
      };
    case actions.filterTraining:
      return {
        ...state,
        filter: {
          ...state.filter,
          local: {
            ...state.filter.local,
            training: action.training,
          },
        },
      };
    case actions.filterMyChats:
      return {
        ...state,
        filter: {
          ...state.filter,
          local: {
            ...state.filter.local,
            myChats: action.myChats,
          },
        },
      };
    case actions.mySupportedChats:
      return {
        ...state,
        mySupportedChats: action.mySupportedChats,
      };
    case actions.infoChat:
      return {
        ...state,
        infoChat: action.infoChat,
      };
    case actions.professionals:
      return {
        ...state,
        professionals: action.professionals,
      };
    case actions.specialties:
      return {
        ...state,
        specialties: action.specialties,
      };
    case actions.labelsConfiguration:
      return {
        ...state,
        labelsConfiguration: action.labelsConfiguration,
      };
    case actions.templatesSent:
      return {
        ...state,
        templatesSent: action.templates,
      };
    case actions.templates:
      return {
        ...state,
        templates: action.templates,
      };
    case actions.alert:
      return {
        ...state,
        alert: { ...state.alert, ...action.alert },
      };
    case actions.commonSpecialties:
      return {
        ...state,
        commonSpecialties: [...action.commonSpecialties],
      };
    case actions.openSection:
      return {
        ...state,
        openSection: { ...state.openSection, ...action.openSection },
      };
    case actions.changeLoading: {
      if (!state.loading || (state.loading && !state.loading.loading)) {
        return {
          ...state,
          loading: action.loading,
        };
      }
      if (state.loading && action.loading.priority <= state.loading.priority) {
        return {
          ...state,
          loading: action.loading,
        };
      }
      return state;
    }
    case actions.openPatientPopup:
      return {
        ...state,
        patientPopup: action.patientPopup,
      };
    case actions.message: {
      return {
        ...state,
        message: action.message,
      };
    }
    case actions.lastUpdate: {
      return {
        ...state,
        lastUpdate: action.lastUpdate,
      };
    }
    case actions.organization: {
      return {
        ...state,
        organization: action.organization,
      };
    }
    case actions.organizations: {
      return {
        ...state,
        organizations: action.organizations,
      };
    }
    case actions.prestobotsConfig: {
      return {
        ...state,
        prestobotsConfig: action.config,
      };
    }
    case actions.configAPI: {
      return {
        ...state,
        configAPI: action.configAPI,
      };
    }
    case actions.messages: {
      return {
        ...state,
        messages: action.messages,
      };
    }
    case actions.kpiDate: {
      return {
        ...state,
        kpiDate: action.kpiDate,
      };
    }
    case actions.isSupportChatBotOpen: {
      return {
        ...state,
        isSupportChatBotOpen: action.isSupportChatBotOpen,
      };
    }
    case actions.graphicsDescriptions: {
      return {
        ...state,
        graphicsDescriptions: action.graphicsDescriptions,
      };
    }
    case actions.clear:
      return initialState;
    default:
      return state;
  }
};
